import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";

// — Get one by ID
export const fetchLoginStaffById = createAsyncThunk(
  "loginStaff/fetchById",
  async (staffGroupId) => {
    const { data } = await api.get(
      API_ENDPOINTS.security.staffGroups.getSecurityByStaffID + staffGroupId
    );
    return data;
  }
);

// — Create a new staff‐group
